import { render, staticRenderFns } from "./select-profile-section-attribute.vue?vue&type=template&id=49da1964&"
import script from "./select-profile-section-attribute.vue?vue&type=script&lang=ts&"
export * from "./select-profile-section-attribute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports